import React from 'react'
import styled from 'styled-components'
import travelImage from '../images/travel.svg'
import eatImage from '../images/eat.svg'
import petlImage from '../images/dogs.svg'
import entImage from '../images/books.svg'
import otherslImage from '../images/others.svg'

const Wrapper = styled.span`
  display: inline-block;
  width: 25px;
  height: 25px;
  margin-right: 8px;
  img {
    width: 25px;
    height: 25px;
  }
`

const getImageSrc = slug => {
  if (slug == 'travel') return travelImage
  if (slug == 'eat') return eatImage
  if (slug == 'pet') return petlImage
  if (slug == 'ent') return entImage
  if (slug == 'others') return otherslImage
}

const Container = props => {
  return (
    <Wrapper>
      <img src={getImageSrc(props.tag.slug)} />
    </Wrapper>
  )
}

export default Container
